/**
 * Showroom selection header tooltip — Figma location tooltip (desktop + mobile).
 */

const ShowroomSelectionPopup = {
  parts: [
    'arrow',
    'panel',
    'contentStack',
    'textBlock',
    'title',
    'showroomLink',
    'description',
    'loadingText',
    'buttonRow',
    'confirmButton',
    'changeButton',
    'ctaButton',
    'buttonSkeleton',
    'closeButton',
  ],
  baseStyle: {
    arrow: {
      bg: '#1B1A18',
      clipPath: 'polygon(50% 0, 0 100%, 100% 100%)',
      height: '6px',
      position: 'absolute',
      top: '-6px',
      transform: 'translateX(-50%)',
      width: '12px',
    },
    panel: {
      bg: '#1B1A18',
      borderRadius: '4px',
      boxShadow: 'xl',
      maxWidth: {base: '500px', lg: '310px'},
      overflow: 'hidden',
      p: 4,
      position: 'relative',
      width: '100%',
    },
    contentStack: {
      align: 'stretch',
      spacing: 2,
    },
    textBlock: {
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      pr: 8,
    },
    title: {
      as: 'h3',
      color: 'white',
      fontFeatureSettings: "'lnum' 1, 'pnum' 1",
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: 1.2,
      mb: 0,
    },
    showroomLink: {
      _hover: {opacity: 0.8},
      as: 'a',
      color: 'white',
      display: 'block',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1.4,
      textDecoration: 'underline',
    },
    description: {
      color: 'white',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1.4,
      sx: {
        '& a, & strong, & b': {
          fontsize: '14px',
        },
      },
    },
    loadingText: {
      color: 'white',
      fontSize: {base: '12px', lg: '14px'},
      fontWeight: 400,
      lineHeight: 1.4,
    },
    buttonRow: {
      spacing: 3,
    },
    confirmButton: {
      _hover: {bg: 'whiteAlpha.100'},
      bg: 'transparent',
      borderColor: 'white',
      borderRadius: '4px',
      borderWidth: '1px',
      color: 'white',
      flex: 1,
      fontSize: '13px',
      fontWeight: 600,
      h: 'auto',
      lineHeight: 1.2,
      px: 6,
      py: 3,
    },
    changeButton: {
      _hover: {bg: 'gray.100'},
      bg: 'white',
      borderRadius: '4px',
      color: '#32312F',
      flex: 1,
      fontSize: '13px',
      fontWeight: 600,
      h: 'auto',
      lineHeight: 1.2,
      px: 6,
      py: 3,
    },
    ctaButton: {
      _focusVisible: {
        boxShadow: '0 0 0 3px rgba(255, 255, 255, 0.45)',
        outline: '2px solid transparent',
      },
      _hover: {bg: 'gray.100'},
      bg: 'white',
      borderRadius: '4px',
      color: '#32312F',
      fontSize: '13px',
      fontWeight: 600,
      h: 'auto',
      lineHeight: 1.2,
      px: 6,
      py: 3,
      width: '100%',
    },
    buttonSkeleton: {
      endColor: 'gray.600',
      height: '36px',
      startColor: 'gray.700',
    },
    closeButton: {
      alignItems: 'center',
      bg: 'transparent',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      h: '24px',
      justifyContent: 'center',
      minH: '24px',
      minW: '24px',
      p: 0,
      position: 'absolute',
      right: 4,
      top: 4,
      w: '24px',
      _hover: {opacity: 1},
      _focus: {
        boxShadow: 'none',
        outline: 'none',
      },
      _focusVisible: {
        boxShadow: '0 0 0 3px rgba(255, 255, 255, 0.45)',
        outline: '2px solid transparent',
      },
    },
  },
};

export default ShowroomSelectionPopup;
